<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Tipos de movimiento de nómina</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table :deleteButton="puede_anular" :createButton="puede_crear" :editButton="false" ref="tipoMovimiento" @crear="crear" :path="path" @eliminar="eliminar" :columns="[
          {
            display: 'Código',
            value: 'codigo',
          },
          {
            display: 'Tipo',
            value: 'descripcion_tipo',
          },
          {
            display: 'Tipo de aplicación',
            value: 'descripcion_tipo_aplicacion',
          },
          {
            display: 'Descripción',
            value: 'descripcion',
          },
          {
            display: 'Creador',
            value: 'creador.nombre',
          },
          {
            display: 'Fecha creación',
            value: 'created_at',
          },
          {
            display: 'Modificador',
            value: 'modificador.nombre',
          },
          {
            display: 'Fecha modificación',
            value: 'updated_at',
          },
        ]"></k-table>
      </div>
    </div>
    <modal name="tipoMovimientoModal" scrollable resizable reset adaptive height="auto" width="60%">
      <tipo-movimiento @cancelar="cancelar" @saved="savedTipoMovimiento" ref="tipoMovimientoModal" v-model="selectedTipoMovimiento"></tipo-movimiento>
    </modal>
  </div>
</template>

<script>
import TipoMovimiento from './TipoMovimiento.vue';
export default {
    components: {
        TipoMovimiento
    },
  data: function () {
    return {
      path: url + "/tipos-movimiento-nomina",
      selectedTipoMovimiento: null,
      puede_anular: false,
      puede_crear: false
    };
  },
  methods: {
    cargarDatos: function () {
        axios.get(this.path + '/datos').then(({data}) => {
            this.puede_anular = data.puede_anular;
            this.puede_crear = data.puede_crear;
        }).catch(() => {
            swal('Hubo un error al cargar los datos.', 'Error', 'error');
        });
    },
    cancelar: function () {
      this.$modal.hide("tipoMovimientoModal");
    },
    savedTipoMovimiento: function () {
      this.$modal.hide("tipoMovimientoModal");
      this.$refs.tipoMovimiento.loadRows();
    },
    crear: function () {
      this.selectedTipoMovimiento = {
        codigo: "",
        descripcion: "",
        tipo: 'G',
        tipo_aplicacion: 'V'
      };
      this.$modal.show("tipoMovimientoModal");
    },
    eliminar: function (tipoMovimiento) {
      swal({
        title:
          "¿Deseas anular el tipo de movimiento seleccionado?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(`${this.path}/${tipoMovimiento.codigo}`, {
              _method: "DELETE",
            })
            .then(() => {
              swal(
                "El tipo de movimiento ha sido anulado exitósamente.",
                "Realizado",
                "success"
              );
              this.$refs.tipoMovimiento.loadRows();
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
  },
  mounted: function () {
    this.cargarDatos();
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/ListaTiposMovimiento.vue